import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoaderContainer from "../../../components/LoaderContainer";
import { CustomTitle } from "../../../components/Custom/CustomTypography";
import { Box, Container, Typography } from "@mui/material";
import api from "../../../globals/axios";
import { useTranslation } from "react-i18next";
import CustomProgramCard from "../../../components/Custom/CustomProgramCard";
import { useAlert } from "../../../components/Alert";
import { isNotNullOrEmptyArray } from "../../../globals/utils";

const ProgramSignup = () => {
  const { t } = useTranslation();
  const { cropId } = useParams();
  const [availablePrograms, setAvailablePrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    fetchProgramsByCrop(cropId);
  }, [cropId]);

  const fetchProgramsByCrop = async (cropId) => {
    if (!cropId) return;
    setLoading(true);
    try {
      const result = await api.get(
        `/farm-activities/programs/by-crop/?crop_id=${cropId}`
      );
      setAvailablePrograms(result.data.data);
    } catch (err) {
      console.error("Error fetching programs by crop:", err);
      setAvailablePrograms([]);
    } finally {
      setLoading(false);
    }
  };

  const handleProgramSignup = async (programId) => {
    try {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      await api.post(`/farm-activities/signup-program/`, {
        program_id: programId,
        start_date: formattedDate,
      });
      showAlert("success", t("Successfully signed up for the program!"));
      navigate("/farmer/programs/");
    } catch (error) {
      console.error("Error signing up for program:", error);
      showAlert("error", t("Failed to sign up for the program."));
    }
  };

  const renderProgramData = (program) => {
    const isSugarcane =
      program?.commodity_details?.name.toLowerCase() === "sugarcane";

    const data = [
      {
        label: t("Program Name"),
        value: program.name || t("N/A"),
        type: "text",
      },
      {
        label: t("Crop Name"),
        value: program.commodity_details.name || t("N/A"),
        type: "text",
      },
    ];

    if (isSugarcane) {
      data.push(
        {
          label: t("Cycle"),
          value: program.cycle || t("N/A"),
          type: "text",
        },
        {
          label: t("Is Ratoon"),
          value: program.is_ratoon ? t("Yes") : t("No"),
          type: "text",
        }
      );
    }

    return data;
  };

  return (
    <LoaderContainer loading={loading}>
      <Container
        maxWidth="xs"
        style={{
          height: "91vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {isNotNullOrEmptyArray(availablePrograms) ? (
          <>
            <CustomTitle>{t("Available Programs")}</CustomTitle>
            <div
              style={{
                overflowY: "auto",
                height: "70%",
                textAlign: "center",
                maxHeight: "70%",
                marginTop: "10px",
              }}
            >
              {availablePrograms.map((program) => (
                <Box key={program.id} sx={{ mb: 2 }}>
                  <CustomProgramCard
                    id={program.id}
                    data={renderProgramData(program)}
                    onView={() => handleProgramSignup(program.id)}
                    viewText={
                      program.registered ? t("Already Signed Up") : t("Sign Up")
                    }
                    disabled={program.registered}
                  />
                </Box>
              ))}
            </div>
          </>
        ) : (
          <Typography variant="body1" sx={{ mt: 2, textAlign: "center" }}>
            {t("No available programs found for the selected crop.")}
          </Typography>
        )}
      </Container>
    </LoaderContainer>
  );
};

export default ProgramSignup;
